import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "./components/Navbar";
import ReceptTable from "./components/ReceptTable";
import { goLogin, getPermission, getStampTime } from "./js/main";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import Conf from "./Conf";
import PrintIcon from "@material-ui/icons/Print";

// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableCell from "@material-ui/core/TableCell";
// import TableContainer from "@material-ui/core/TableContainer";
// import TableHead from "@material-ui/core/TableHead";
// import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import PageHead from "./components/PageHead";

const current_path = Conf.frontendURL + "receipt";
const page_title = "รายงานการใช้ใบเสร็จ";
const cookie = JSON.parse(localStorage.getItem(Conf.cookieName));
export default function Recept(props) {
  const [profile, setProfile] = useState(null);
  const [filter, setFilter] = useState(null);
  const [report, setReport] = useState(null);
  useEffect(() => {
    async function getAuth() {
      if (cookie && cookie.token) {
        var auth = await getPermission(cookie.token);
        if (auth === false) goLogin(current_path);
        else setProfile(auth.profile);
        let stampDate = await getStampTime();
        stampDate = stampDate.iso_date;
        setFilter({
          limit: 5000,
          skip: 0,
          start_date: stampDate,
          end_date: stampDate,
        });
      } else goLogin(current_path);
    }
    if (!profile) getAuth();
  }, [profile]);

  useEffect(() => {
    async function getBills() {
      let Filter = JSON.parse(JSON.stringify(filter));
      // Create Query
      let end_date = new Date(Filter.end_date);
      end_date = end_date.setDate(end_date.getDate() + 1);
      end_date = await getStampTime(end_date);
      end_date = end_date.iso_date;
      Filter.query = JSON.stringify({
        $and: [
          { transactionDateandTime: { $gte: Filter.start_date } },
          { transactionDateandTime: { $lt: end_date } },
        ],
      });

      let Bills = await axios.post(Conf.digitalpayBackend + "bill", Filter, {
        headers: { Authorization: cookie.token },
      });
      let Report = {
        transaction: [],
        total_bill: 0,
        total_cancel: 0,
      };
      for (let bill of Bills.data.bills) {
        let dt = await getStampTime(bill.transactionDateandTime);
        dt = dt.iso_date;
        let i = Report.transaction.findIndex((j) => j.bill_date === dt);
        let canceled = (bill.canceled && bill.canceled.status) || false;
        if (canceled === true) Report.total_cancel++;
        Report.total_bill++;
        if (i < 0) {
          let cancel = [];
          if (canceled === true) cancel.push(bill.bill_id);
          Report.transaction.push({
            bill_date: dt,
            start_bill: bill.bill_id,
            end_bill: bill.bill_id,
            bill_count: 1,
            canceled: cancel,
          });
        } else {
          let trans = Report.transaction[i];
          if (trans.start_bill > bill.bill_id) {
            trans.start_bill = bill.bill_id;
          }
          if (trans.end_bill < bill.bill_id) {
            trans.end_bill = bill.bill_id;
          }
          trans.bill_count++;
          if (canceled === true) trans.canceled.push(bill.bill_id);
          Report.transaction[i] = trans;
        }
      }
      setReport(Report);
    }
    if (filter) getBills();
  }, [filter]);

  function printReport() {
    document.getElementById("printFrame").src = "";
    if (report) {
      cookie.print = report;
      cookie.print.subTitle =
        "รายงานการใช้ใบเสร็จตั้งแต่ " +
        filter.start_date +
        " ถึง " +
        filter.end_date;
      localStorage.setItem(Conf.cookieName, JSON.stringify(cookie));

      document.getElementById("printFrame").src =
        process.env.PUBLIC_URL + "/print/receipt";
    }
  }
  return (
    <div>
      {profile && (
        <>
          <Navbar />
          <main className="content">
            <PageHead
              icon={<MonetizationOnIcon style={{ fontSize: "2rem" }} />}
              title={page_title}
              profile={profile}
            />
            {filter && (
              <FilterForm
                filter={filter}
                onChangeFilter={(id, value) =>
                  setFilter({ ...filter, [id]: value })
                }
              />
            )}
            <br />
            {/* {report && <ReportTable report={report} />} */}
            {report && (
              <>
                <Paper>
                  <ReceptTable report={report} />
                </Paper>
                <div style={{ paddingTop: "20px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<PrintIcon />}
                    style={{ width: "250px" }}
                    onClick={printReport}
                  >
                    Print
                  </Button>
                </div>
              </>
            )}
          </main>
        </>
      )}
    </div>
  );
}

const FilterForm = (props) => {
  const { filter, onChangeFilter } = props;
  function changeDate(date, date2, id) {
    onChangeFilter(id, date2);
  }
  return (
    <div>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={1}>
          <Grid item>
            <KeyboardDatePicker
              margin="normal"
              autoOk
              id="start_date"
              label="From Date"
              format="yyyy-MM-dd"
              value={filter.start_date}
              onChange={(date, date2) => changeDate(date, date2, "start_date")}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              inputProps={{
                readOnly: true,
              }}
              inputVariant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item>
            <KeyboardDatePicker
              margin="normal"
              autoOk
              id="end_date"
              label="to Date"
              format="yyyy-MM-dd"
              value={filter.end_date}
              onChange={(date, date2) => changeDate(date, date2, "end_date")}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              inputProps={{
                readOnly: true,
              }}
              inputVariant="outlined"
              fullWidth
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </div>
  );
};

/*
const ReportTable = props => {
  const { report } = props;
  return (
    <div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>วันที่</TableCell>
              <TableCell>ใบเสร็จเลขที่</TableCell>
              <TableCell>ถึงใบเสร็จเลขที่</TableCell>
              <TableCell>จำนวนใบเสร็จที่ใช้</TableCell>
              <TableCell>จำนวนใบเสร็จที่ยกเลิก</TableCell>
              <TableCell>ยกเลิกใบเสร็จเลขที่</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {report.transaction.map((trans, key) => (
              <TableRow key={key}>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.bill_date}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.start_bill}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.end_bill}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.bill_count}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.canceled.length}
                </TableCell>
                <TableCell className="td" align="center">
                  {trans.canceled.map((cancel, key) => (
                    <div key={key} style={{ paddingBottom: "3px" }}>
                      {cancel}
                    </div>
                  ))}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell className="td" align="center" colSpan={3}>
                <div style={{ fontWeight: 400, textAlign: "center" }}>รวม</div>
              </TableCell>
              <TableCell className="td" align="center">
                <div style={{ fontWeight: 400, textAlign: "center" }}>
                  {report.total_bill}
                </div>
              </TableCell>
              <TableCell className="td" align="center">
                <div style={{ fontWeight: 400, textAlign: "center" }}>
                  {report.total_cancel}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
*/
